export const defaultTheme = { primary: '#f06290', secondary: '#03012B', pallet: 'The Blues' };
